import { createSvgIcon } from 'shared/icons/IconUtils';

export const LoadSuggestionsSidebarIcon = createSvgIcon(
  'LoadSuggestionsSidebar',
  <path
    d="M21.2 3.5C19.6 2.9 16.5 2 12.5 2C8.5 2 5.4 2.9 3.8 3.5C3 3.7 2.5 4.5 2.5 5.3V16.6C2.5 17.4 3 18.2 3.8 18.5C5.2 19 7.5 19.7 10.5 19.9V21.6C10.5 21.9 10.9 22.1 11.3 21.9L14.9 19.9C17.7 19.6 19.9 19 21.2 18.6C22 18.3 22.5 17.6 22.5 16.7V5.3C22.5 4.5 22 3.7 21.2 3.5ZM12.5 18C12.5 14.1 9.4 11 5.5 11C9.4 11 12.5 7.9 12.5 4C12.5 7.9 15.6 11 19.5 11C15.6 11 12.5 14.1 12.5 18Z"
    fill="currentColor"
  />,
);
